
import { library } from '@fortawesome/fontawesome-svg-core';

import { faChartBar, faPlusSquare } from '@fortawesome/free-solid-svg-icons'

library.add([
  faChartBar,
  faPlusSquare
])
